import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

import Expander from '../Expander/Expander';

const useStyles = makeStyles<AlyceTheme>(({ palette, spacing }) => ({
  message: {
    height: 'auto',
    position: 'relative',
    width: 'auto',
    maxWidth: 500,
    backgroundColor: palette.common.white,
    transition: 'height .2s',
    padding: spacing(1),
    borderRadius: 4,
    direction: 'ltr',
    boxShadow: '0 2px 10px 0 rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.2)',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      width: 500,
    },
  },
}));

export interface IExpandedWrapperProps {
  children: React.ReactNode;
  header?: React.ReactNode;
}

const ExpandedWrapper = ({ children, header = '' }: IExpandedWrapperProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Expander>
      {header}
      <Box position="relative" pt={[0, 2]}>
        <Box className={classes.message} my={1} mx={[1, 'auto']}>
          <Box pt={3} pr={3} pb={4} pl={3} border={1} borderColor="border.grey" borderRadius="4px">
            {children}
          </Box>
        </Box>
      </Box>
    </Expander>
  );
};

export default ExpandedWrapper;
